import type { MailboxType } from 'owa-client-types';
import type { AccountSource } from '../store/schema/AccountSourceList';

export function updateMailboxInfo(accountSource: AccountSource) {
    if (accountSource.m365mailbox) {
        accountSource.mailboxInfo = {
            type: accountSource.m365mailbox.type as MailboxType,
            userIdentity: accountSource.m365mailbox.userIdentity,
            mailboxSmtpAddress: accountSource.m365mailbox.emailAddress,
            auxiliaryMailboxGuid: accountSource.m365mailbox.auxiliaryMailboxGuid,
            sourceId: accountSource.sourceId,
        };
    }
}
